export class AutocompleteDTO
{
    key: string="";
    value: string="";
   
}